<template>
  <div>
    <div class="systemHeader">
      <router-link to="/LookHistory" class="systemTitle pointer">< 返回上一页</router-link>
      <div class="systemCalendar">
        <span class="calendarStart">计算起点时间</span>
        <span class="calendarTime">2017-03</span>
      </div>

      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>评估体系</el-breadcrumb-item>
          <el-breadcrumb-item>体系配置</el-breadcrumb-item>
          <el-breadcrumb-item>配置历史查询</el-breadcrumb-item>
          <el-breadcrumb-item v-if="navState==1">体系配置</el-breadcrumb-item>
          <el-breadcrumb-item v-if="navState==2">积分</el-breadcrumb-item>
          <el-breadcrumb-item v-if="navState==3">星级</el-breadcrumb-item>
          <el-breadcrumb-item v-if="navState==4">信用</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="tabPages">
      <div class="systemNav">
        <div v-for="(item,index) in pages" class="systemNavWrap" :key="index">
          <div @click="navState = index+1" class="pages pointer"
               :class="{'isActive': navState == index+1}">
            <span>
              <img :src="item.checkedIcon" v-show="navState == index+1"/>
              <img :src="item.icon" v-show="navState != index+1"/>
              {{item.name}}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <System v-if="navState == 1"/>
      <Score v-if="navState == 2"/>
      <Star v-if="navState == 3" :scoreType="2" key="星级"/>
      <Star v-if="navState == 4" :scoreType="3" key="信用"/>
    </div>
  </div>
</template>

<script>
  //韩金辰180718优化整理。组件每次销毁重置
  import Score from './zScore.vue'
  import Star from './zStar.vue'
  import System from './zSystem.vue'

  export default {
    name: 'lookHistoryTwo',
    components: {
      Score,
      Star,
      System
    },
    data() {
      return {
        pages: [{
          name: '体系配置',
          icon: require("../../common/images/icon-tixipeizhi.png"),
          checkedIcon: require("../../common/images/icon-tixipeizhiActive.png")
        }, {
          name: '积分',
          icon: require("../../common/images/icon-jifen.png"),
          checkedIcon: require("../../common/images/icon-jifenActive.png")
        }, {
          name: '星级',
          icon: require("../../common/images/icon-xingji.png"),
          checkedIcon: require("../../common/images/icon-xingjiActive.png")
        }, {
          name: '信用',
          icon: require("../../common/images/icon-xinyong.png"),
          checkedIcon: require("../../common/images/icon-xinyongActive.png")
        }],
        navState: 1,
      };
    },
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .el-breadcrumb__item:last-child > .el-breadcrumb__inner {
    color: #8299dc !important;
  }

  .systemHeader {
    height: 60px;
    background: white;
    position: relative;
    .systemTitle {
      position: absolute;
      top: 14px;
      left: 46%;
      padding: 5px 15px;
      text-align: center;
      border: none;
      border-radius: 20px;
      color: white;
      background-color: #8299dc;
      line-height: 22px;
    }
    .systemCalendar {
      margin-left: 20px;
      display: inline-block;
      width: 230px;
      height: 60px;
      line-height: 60px;
      .calendarStart {
        color: #676767;
        margin-right: 30px;
      }
      .calendarTime {
        font-size: 28px;
        vertical-align: middle;
      }
    }
  }

  .tabPages {
    height: 32px;
    position: relative;
    padding: 19px 0;
    .systemNav {
      float: left;
      .systemNavWrap {
        display: inline-block;
        img {
          margin-right: 5px;
        }
        .pages {
          width: 150px;
          line-height: 30px;
          text-align: center;
          border: 1px solid transparent;
          border-radius: 20px;
          margin: 0 15px;
          display: inline-block;
          color: #666;
          font-size: 18px;
        }
        .isActive {
          border: 1px solid #2d2c7a !important;
          color: #2d2c7a !important;
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/LookHistoryTwo.vue